import React, { useState } from 'react';
import { FaCompass } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import { AzimuthModeModal } from './AzimuthModeModal';

// Which azimuth datum a continuous survey is on, and for admins the control to
// change it. Sits on its own row immediately above the shot table rather than in
// a toolbar: it is a property of this particular survey, and the shots directly
// beneath it are what it governs — unlike Export or Delete, which mean the same
// thing for every survey.
//
// Shared by the drillhole survey view (TableTab) and the approval page
// (SurveyPreviewTable) so the two cannot drift apart. Renders nothing at all for
// a multishot survey, so neither caller needs its own continuous-tool test.
//
// Absent AzimuthMode means Northseek; every survey uploaded before the field
// existed was derived that way.
export const AzimuthDatumBar = ({ survey, surveyKey, canEdit, onSurveyUpdated }) => {
    const { t } = useTranslation();
    const [modalOpen, setModalOpen] = useState(false);

    // Only continuous tools have a heading stream to re-derive a datum from.
    if (!(survey?.DeviceName || '').startsWith('FastTrak')) return null;

    const isReference = (survey.AzimuthMode || '').toUpperCase() === 'REFERENCE';

    return (
        <div className="d-flex align-items-center mb-2">
            <span className="small text-muted">
                <strong>{t('azimuthDatum.label')}</strong>{' '}
                {isReference
                    ? <>{t('azimuthDatum.reference', { azimuth: Number(survey.StartAzimuth ?? 0).toFixed(2) })}</>
                    : <>{t('azimuthDatum.northseek')}</>}
            </span>
            {/* The reading is for everyone; only changing it is an admin action,
                matching the endpoints behind it. */}
            {canEdit && (
                <button className="btn btn-primary ms-3" onClick={() => setModalOpen(true)}>
                    <FaCompass /> {t('azimuthDatum.change')}
                </button>
            )}
            {canEdit && (
                <AzimuthModeModal
                    isOpen={modalOpen}
                    surveyKey={surveyKey}
                    survey={survey}
                    onClose={() => setModalOpen(false)}
                    onSurveyUpdated={onSurveyUpdated} />
            )}
        </div>
    );
};
